/**
 * Generated runtime TestId mirror for frontend/src/components/ApprovalPolicyForm.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ApprovalPolicyFormTestIds = {
  btnAddCondition: "btn-add-condition",
  btnAddStep: "btn-add-step",
  btnCancel: "btn-cancel",
  btnSubmit: "btn-submit",
  cardTitleConditions: "card-title-conditions",
  cardTitleSteps: "card-title-steps",
  inputDescription: "input-description",
  inputName: "input-name",
  inputPriority: "input-priority",
  policyTypeReadonly: "policy-type-readonly",
  selectApprovalStrategy: "select-approval-strategy",
  selectConditionField: "select-condition-field",
  selectConditionOperator: "select-condition-operator",
  selectPolicyType: "select-policy-type",
  selectResolverType: "select-resolver-type",
  badge: (opt_code: string) => `badge-${opt_code}`,
  badgePrefix: () => "badge-" as TestIdPrefix,
  option: (pt: string) => `option-${pt}`,
  optionPrefix: () => "option-" as TestIdPrefix,
  badgesConditionValue: (index: number) => `badges-condition-value-${index}`,
  badgesConditionValuePrefix: () => "badges-condition-value-" as TestIdPrefix,
  btnMoveStepDown: (index: number) => `btn-move-step-down-${index}`,
  btnMoveStepDownPrefix: () => "btn-move-step-down-" as TestIdPrefix,
  btnMoveStepUp: (index: number) => `btn-move-step-up-${index}`,
  btnMoveStepUpPrefix: () => "btn-move-step-up-" as TestIdPrefix,
  btnRemoveCondition: (index: number) => `btn-remove-condition-${index}`,
  btnRemoveConditionPrefix: () => "btn-remove-condition-" as TestIdPrefix,
  btnRemoveStep: (index: number) => `btn-remove-step-${index}`,
  btnRemoveStepPrefix: () => "btn-remove-step-" as TestIdPrefix,
  selectConditionValue: (index: number) => `select-condition-value-${index}`,
  selectConditionValuePrefix: () => "select-condition-value-" as TestIdPrefix,
  stepTeamPicker: (index: number) => `step-team-picker-${index}`,
  stepTeamPickerPrefix: () => "step-team-picker-" as TestIdPrefix
} as const;
